<div class="px-7 pt-4">
  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 flex-wrap">
    <!-- Add Samples Button -->
    <button *ngIf="submissionStatus < 2" (click)="openAddSamplesDialog()"
      class="py-2 px-3.5 bg-[var(--primary-dark)] rounded-lg text-xs font-semibold text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">add</span> ADD SAMPLES
    </button>

    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search samples..." [(ngModel)]="searchText" (ngModelChange)="searchLabSamples()"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
    </div>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <div class="flex-1"></div>

    <!-- Date Range -->
    <div class="flex gap-2.5 items-center">
      <ui-datepicker label="START DATE" [value]="filterStartDate" (valueChange)="filterStartDate=$event; filterDateRange()"></ui-datepicker>
      <ui-datepicker label="END DATE" [value]="filterEndDate" (valueChange)="filterEndDate=$event; filterDateRange()"></ui-datepicker>
    </div>
  </div>

  <!-- Samples Table -->
  <app-samples-table
    [submissionStatus]="submissionStatus"
    [callResponse]="dataSource"
    [pinTypeId]="pinTypeId"
    [isDialog]="false"
    [mergeGroups]="mergeGroups"
    (emitSelectedSamples)="removeSamplesDialog($event)"
    (mergeSamples)="mergeSamples($event)"
    (unmergeSamples)="unmergeSamples($event)"
    (removeSample)="removeSampleDialog($event)"
    (paginateChange)="currentPage=$event.currentPage;pageSize=$event.pageSize;getLabSampleListById();">
  </app-samples-table>
</div>
